export const defaultProps = {
  children: "",
  variant: "contained",
  disabled: false,
  startIcon: "",
  endIcon: "",
  color: "primary",
};
